export default "__VITE_ASSET__BBpLGjyy__"